import { render, staticRenderFns } from "./ConventionSections.vue?vue&type=template&id=4bd2240c&scoped=true"
import script from "./ConventionSections.vue?vue&type=script&lang=js"
export * from "./ConventionSections.vue?vue&type=script&lang=js"
import style0 from "./ConventionSections.vue?vue&type=style&index=0&id=4bd2240c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd2240c",
  null
  
)

export default component.exports